import { collection, getDocs, query, runTransaction, where } from 'firebase/firestore';
import { db } from '@/firebase';
import { getTenantCollectionPath } from '../utils/firebase';

async function updateCategoryInProducts(id, categoryData) {
	await runTransaction(db, async (transaction) => {
      const productsRef = collection(db, getTenantCollectionPath('products'));
      const snapshot = await getDocs(productsRef);

      if (!snapshot.empty) {
         let updatedProductsCount = 0;

         snapshot.docs.forEach((productDoc) => {
            const productData = productDoc.data();
            const hasCategory =
               productData.categories &&
               Array.isArray(productData.categories) &&
               productData.categories.some((category) => category.id === id);

            if (hasCategory) {
               const updatedCategories = productData.categories.map((category) => {
                  if (category.id === id) {
                     return {
                        id: id,
                        name: categoryData.name,
                     };
                  }
                  return category;
               });

               transaction.update(productDoc.ref, {
                  categories: updatedCategories,
                  updatedAt: new Date(),
               });

               updatedProductsCount++;
            }
         });
      }
   });
}

export class CategoryFunctions {
	static async updateCategory(id, categoryData) {
		await updateCategoryInProducts(id, categoryData);
	}
}
